module.exports = __webpack_public_path__ + "img/CFCA.4bf25e4b.jpg";